'use client'
import {
  Box,
  Skeleton,
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Image,
  Text,
  Flex,
} from '@chakra-ui/react'

import Pagination from '@/src/app/(lyk-appp)/(sidebar)/earnings/breakdown/modal-section-ui/pagination'
import { useEffect, useState } from 'react'
import MinMinuteModal from '@/src/app/(lyk-appp)/(sidebar)/earnings/breakdown/modal-section-ui/minute'
import { useCreatorBreakdown } from '@/src/queries/earnings/breakdown/creator'
import NoEarningsYet from './new-breakdown/no-earnings'
import { usePathname, useRouter } from 'next/navigation'

export const LoadingGridCard = () => {
  return (
    <Tr>
      <Td py={3}>
        <Skeleton width="135px" aspectRatio={16 / 9} rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      {/* <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td>
      <Td py={3}>
        <Skeleton width="50px" height="20px" rounded="md" />
      </Td> */}
    </Tr>
  )
}

export default function NewCreator({
  sreach_text,
  sortBy,
  startDate,
  endDate,
}: {
  sreach_text?: string
  sortBy: string
  startDate?: Date
  endDate?: Date
}) {
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [isMinMinuteOpen, setMinMinuteOpen] = useState(false)
  const [selectedDuration, setSelectedDuration] = useState(0)
  const itemsPerPage = 10
  const { data, status } = useCreatorBreakdown({
    limit: itemsPerPage,
    offset: currentPage - 1,
    sreach_text: sreach_text || '',
    startDate,
    endDate,
    sortBy,
  })
  const pathname = usePathname()
  const router = useRouter()
  const isCreatorAllVideo =
    pathname === '/creator-analytics/all-videos' ? true : false

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handleVideoDetail = (eventId: string) => {
    router.push(`/creator-analytics/${eventId}`)
  }

  const handleTotalPageChange = (page: number) => {
    setTotalPages(page)
  }

  const handleMinMinuteOpen = (duration: number) => {
    setSelectedDuration(duration)
    setMinMinuteOpen(true)
  }

  const formatWatchTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60

    return `${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  useEffect(() => {
    if (data && data?.pages[0].pageCount) {
      handleTotalPageChange(data?.pages[0].pageCount)
    }
  }, [data])

  return (
    <>
      <MinMinuteModal
        isOpen={isMinMinuteOpen}
        onClose={() => setMinMinuteOpen(false)}
        duration={selectedDuration}
      />

      <Box my={5}>
        <TableContainer className="text-[#656565]">
          <Table variant="simple">
            <Thead
              overflowX="auto"
              sx={{
                '::-webkit-scrollbar': {
                  display: 'none',
                },
                th: {
                  textTransform: 'none',
                },
              }}
              className="font-medium"
            >
              <Tr fontWeight={700}>
                <Th py={3} fontSize={15}>
                  Preview
                </Th>

                <Th py={3} fontSize={15}>
                  Title
                </Th>

                <Th py={3} fontSize={15}>
                  Date Uploaded
                </Th>

                {/* <Th py={3} fontSize={15}>
                  Watchtime
                </Th> */}

                <Th py={3} fontSize={15}>
                  <div className="flex items-center gap-1">
                    {/* <Image
                      boxSize="20px"
                      src={'/logo-color-circle.svg'}
                      alt="lykcoin"
                    />
                    LYK Coins */}
                    Watchtime Earnings (in LYK Coins)
                  </div>
                </Th>

                {/* <Th py={3} fontSize={15}>
                  Views
                </Th> */}

                <Th py={3} fontSize={15}>
                  Comments
                </Th>

                <Th py={3} fontSize={15}>
                  Likes
                </Th>
              </Tr>
            </Thead>

            <Tbody mt={2}>
              {status === 'pending' &&
                Array.from({ length: 4 }).map((_, i) => (
                  <LoadingGridCard key={i} />
                ))}

              {status === 'success' &&
                data &&
                data.pages.length > 0 &&
                data.pages[0].creatorBreakdown.length === 0 && (
                  <Tr>
                    <Td colSpan={8}>
                      <NoEarningsYet type="creator" />
                    </Td>
                  </Tr>
                )}

              {status === 'success' &&
                data?.pages?.map((page) =>
                  page.creatorBreakdown
                    .slice(
                      0,
                      pathname === '/creator-analytics'
                        ? 5
                        : page.creatorBreakdown.length
                    )
                    .map((item, j) => (
                      <Tr
                        key={j}
                        bg={item.duration < 180 ? '#ED837F20' : 'white'}
                      >
                        <Td pt={2} pb={4} pl={0} className="flex gap-2">
                          <Box
                            height={'76px'}
                            width={'160px'}
                            onClick={() => handleVideoDetail(item.eventId)}
                          >
                            <Image
                              src={item.thumbnailImage}
                              alt={item.eventTitle}
                              objectFit="cover"
                              aspectRatio={16 / 9}
                              height={'76px'}
                              borderRadius={'6.2px'}
                            />
                          </Box>
                        </Td>

                        <Td>
                          <Box
                            className="flex flex-col text-[#656565]"
                            width={'70%'}
                          >
                            <Text
                              className="text-md font-medium"
                              // style={{
                              //   display: '-webkit-box',
                              //   WebkitLineClamp: 2,
                              //   WebkitBoxOrient: 'vertical',
                              //   overflow: 'hidden',
                              //   textOverflow: 'ellipsis',
                              //   whiteSpace: 'pre-wrap',
                              //   maxHeight: '3em',
                              //   lineHeight: '1.5em',
                              // }}
                            >
                              {item.eventTitle}
                            </Text>
                          </Box>
                        </Td>

                        <Td
                          py={6}
                          fontSize={15}
                          fontWeight={500}
                          color={'#656565'}
                        >
                          {new Date(item.createdAt).toLocaleDateString(
                            'en-US',
                            {
                              month: '2-digit',
                              day: '2-digit',
                              year: '2-digit',
                            }
                          )}
                        </Td>

                        {/* <Td
                          py={6}
                          color={'#656565'}
                          fontSize={23}
                          fontWeight={500}
                          textAlign={'center'}
                        >
                          <Flex className="flex-col justify-center">
                            <Flex className="items-center justify-center gap-2">
                              {formatWatchTime(item.watch_time)}
                            </Flex>
                          </Flex>
                        </Td> */}
                        {/* {item.UniqueWatchTime} */}

                        <Td
                          py={6}
                          color={'#656565'}
                          fontSize={20}
                          fontWeight={500}
                          textAlign={'center'}
                        >
                          <Flex className="items-center justify-center gap-1">
                            {item.duration < 180 ? (
                              <>
                                <Image
                                  src={'/rewards/breakdown/redExclamatory.svg'}
                                  alt="Icon"
                                  w={4}
                                  h={4}
                                  onClick={() => {
                                    handleMinMinuteOpen(item.duration)
                                  }}
                                  className="cursor-pointer"
                                />
                                <Text
                                  color={'#ED837F'}
                                  fontSize={16}
                                  fontWeight={600}
                                >
                                  Not eligible
                                </Text>
                              </>
                            ) : (
                              <>{item.lykCoin}</>
                            )}
                            {/* {item.lykCoin === '0.0000' ? ( */}
                            {/* <Image
                    src={'/rewards/breakdown/exclamatoryGray.svg'}
                    alt="Icon"
                    w={4}
                    h={4}
                    onClick={() => {
                      handleMessage()
                    }}
                  /> */}
                            {/* ) : null} */}
                          </Flex>
                        </Td>

                        {/* <Td
                          py={6}
                          color={'#656565'}
                          fontSize={23}
                          fontWeight={500}
                          textAlign={'center'}
                        >
                          <Flex className="flex-col justify-center">
                            <Flex className="items-center justify-center gap-2">
                              {item.watchCount}
                            </Flex>
                          </Flex>
                        </Td> */}

                        <Td
                          py={6}
                          color={'#656565'}
                          fontSize={23}
                          fontWeight={500}
                          textAlign={'center'}
                        >
                          <Flex className="flex-col justify-center">
                            <Flex className="items-center justify-center gap-2">
                              {item.commentCount}
                            </Flex>
                          </Flex>
                        </Td>

                        <Td
                          py={6}
                          color={'#656565'}
                          fontSize={23}
                          fontWeight={500}
                          textAlign={'center'}
                        >
                          <Flex className="flex-col justify-center">
                            <Flex className="items-center justify-center gap-2">
                              {item.likeCount}
                            </Flex>
                          </Flex>
                        </Td>
                      </Tr>
                    ))
                )}
            </Tbody>
          </Table>
        </TableContainer>
        {isCreatorAllVideo && (
          <Pagination
            totalPages={totalPages}
            itemsPerPage={10}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )}
      </Box>
    </>
  )
}
